import { NgModule } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatNativeDateModule } from '@angular/material';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { FullCalendarModule } from 'ng-fullcalendar';
import { SweetAlert2Module } from '@toverux/ngx-sweetalert2';
import { WebcamModule } from 'ngx-webcam';
import { ChartsModule } from 'ng2-charts';
import { NgxSpinnerModule } from 'ngx-spinner';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { AppRoutingModule } from './app-routing.module';
import { DemoMaterialModule } from './material-module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './layouts/header.component';
import { LoginComponent } from './login/login.component';
import { UploadpicComponent } from './verify/upload-pic.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { HomeComponent } from './home/home.component';
import { BatchdetailComponent } from './batch/batch-detail.component';
import { CompletebatchComponent } from './batch/complete-batch.component';
import { ProctorComponent } from './proctor/proctor.component';
import { TestComponent } from './test/test-page.component';
import { VivaComponent } from './test/viva-page.component';
import { StudentsComponent } from './student/students.component';
import { StudentlistComponent } from './student/student-list.component';
import { LaunchpageComponent } from './verify/launch-page.component';
import { ExamlistComponent } from './examlist/exams-list.component';
import { VivaPcComponent } from './viva-pc/viva-pc.component';

import { OnlyNumber } from './number.directive';

import { VgCoreModule } from 'videogular2/core';
import { VgControlsModule } from 'videogular2/controls';
import { VgOverlayPlayModule } from 'videogular2/overlay-play';
import { VgBufferingModule } from 'videogular2/buffering';

import { AlertComponent } from './_directives';
import { AuthGuard } from './_guards';
import { JwtInterceptor, ErrorInterceptor, Globals } from './_helpers';
import { AlertService, AuthenticationService, UserService, PhotoauthService, HomeService, DashboardService, BatchService, StudentService, LunchpageService, ExamService } from './_services';
import { PracticalComponent } from './student/practical.component';
import { VideoConfComponent } from './student/video-conf.component';
import { OpentokService } from './_services/opentok.service';
import { PublisherComponent } from './publisher/publisher.component';
import { SubscriberComponent } from './subscriber/subscriber.component';
import { MarksComponent } from './student/marks.component';
import { IntermidiateComponent } from './intermidiate/intermidiate.component';
import { DesStudentListComponent } from './des-student-list/des-student-list.component';
import { DesMarksComponent } from './des-marks/des-marks.component';
import { VivaMarksComponent } from './viva-marks/viva-marks.component';
import { ChatComponent } from './chat/chat.component';
import { DatePipe } from '@angular/common';
import { FeedbackstartComponent }    from './verify/feedback-start.component';
import { FeedbackComponent }    from './verify/feedback.component';
import { CanvasComponent } from './canvas/canvas.component';
import { NewCanvasComponent } from './new-canvas/new-canvas.component';
import { ConstantsService }   from './common/services/constants.service';

@NgModule({
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        FormsModule,
        HttpClientModule,
        DemoMaterialModule,
        ReactiveFormsModule,
        MatNativeDateModule,
        NgbModule,
        FullCalendarModule,
        WebcamModule,
        ChartsModule,
        NgxSpinnerModule,
        VgCoreModule,
        VgControlsModule,
        VgOverlayPlayModule,
        VgBufferingModule,
        SweetAlert2Module.forRoot(),
    ],
    declarations: [
        AppComponent,
        HeaderComponent,
        LoginComponent,
        UploadpicComponent,
        DashboardComponent,
        HomeComponent,
        BatchdetailComponent,
        CompletebatchComponent,
        ProctorComponent,
        TestComponent,
        VivaComponent,
        StudentsComponent,
        StudentlistComponent,
        LaunchpageComponent,
        ExamlistComponent,
        OnlyNumber,
        PracticalComponent,
        VideoConfComponent,
        PublisherComponent,
        SubscriberComponent,
        MarksComponent,
        IntermidiateComponent,
        DesStudentListComponent,
        DesMarksComponent,
        VivaMarksComponent,
        VivaPcComponent,
        FeedbackstartComponent,
        FeedbackComponent,        
        ChatComponent,
        CanvasComponent,
        NewCanvasComponent        
    ],
    entryComponents: [AppComponent, SubscriberComponent],
    bootstrap: [AppComponent],
    providers: [DatePipe,
        Globals,
        AuthGuard,
        AlertService,
        AuthenticationService,
        UserService,
        PhotoauthService,
        HomeService,
        DashboardService,
        BatchService,
        StudentService,
        LunchpageService,
        ExamService,
        OpentokService,
        ConstantsService,
        { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    ]
})
export class AppModule { }

platformBrowserDynamic().bootstrapModule(AppModule);
